export const SMS_MESSAGES = 'messages';
export const SMS_APPOINTMENT = 'appointment';
export const SMS_QUOTE = 'quote';
export const SMS_INVOICE = 'invoice';
